// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Ypk1","label":"Category_label__6PTch","content":"Category_content__3xrsY","header":"Category_header__H9zZJ","location":"Category_location__1fDrN"};